import moment from 'moment';
import _ from 'lodash';

import addInternalNotePanelTemplate from 'panels/addInternalNote/template.html';

const TABS = {
  TOTALS: 'TOTALS',
  TOTALS_BY_USER: 'TOTALS_BY_USER'
};

function Ctrl($scope, $timeout, $q, $state, $stateParams, internalNoteService, dateUtilsService, angularSlideOutPanel, sdkUtils, alertService, modalService, $sce, userPreferencesService, eventService) {
  $scope.TABS = TABS;
  $scope.currentTab = TABS.TOTALS;

  $scope.getNotes = function() {
    $scope.notesLoading = true;

    userPreferencesService.setManagePage('DASHBOARD');

    return internalNoteService.listByVenueId($scope.venueId, {
        date: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC)
      })
      .then(notes => {
        $scope.notes = mapNotes(notes);
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)))
      .finally(() => {
        $scope.notesLoading = false;
      });
  };

  $scope.getEvents = function() {
    $scope.eventsLoading = true;

    return eventService.listByVenueId($scope.venue.id, {
        start: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC),
        end: dateUtilsService.toUTCTimestampWithoutTime($scope.currentDateUTC)
      })
      .then(notes => {
        $scope.notes = mapNotes(notes);
      })
      .catch(response => alertService.error(sdkUtils.getErrorFromResponse(response)))
      .finally(() => {
        $scope.notesLoading = false;
      });
  };

  $scope.addOrUpdateNote = function(note, $event) {
    if ($event) $event.preventDefault();

    const panelInstance = angularSlideOutPanel.open({
      template: addInternalNotePanelTemplate,
      openOn: 'right',
      panelClass: 'add-admission-group-panel-bg',
      controller: 'addInternalNotePanelCtrl',
      backdrop: 'static',
      resolve: {
        venue: [
          () => {
            return this.venue;
          }
        ],
        note: [
          () => {
            return note;
          }
        ],
        date: [
          () => {
            return this.currentDateUTC;
          }
        ]
      }
    });

    panelInstance.result
      .then(result => {
        if (result === false) return;

        if (result.note) {
          if (!result.added) {
            const existingNote = _.findWhere($scope.notes, {
              id: result.note.id
            });

            if (existingNote) _.extend(existingNote, result.note);

            $scope.notes = mapNotes($scope.notes);

            alertService.success('Note updated');
          } else {
            $scope.notes = $scope.notes || [];
            $scope.notes.push(result.note);

            $scope.notes = mapNotes($scope.notes);

            alertService.success('Note added');
          }
        }
      });
  };

  $scope.deleteNote = function(note, $event) {
    if ($event) $event.preventDefault();

    modalService.confirmation({
        modalHeader: 'Delete Note',
        modalMessage: 'Are you sure you want to delete this note?',
        confirmBtnTxt: 'Delete Note',
        confirmingBtnTxt: 'Deleting...',
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          internalNoteService.deleteById(note.id)
            .then(() => {
              const index = $scope.notes.indexOf(note);

              $scope.notes.splice(index, 1);

              alertService.success('Note deleted');
            })
            .catch(response => {
              alertService.error(sdkUtils.getErrorFromResponse(response));
            })
            .finally(() => {
              result.modalInstance.close();
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  $scope.changeTab = function($event, tab) {
    if ($event) $event.preventDefault();

    $scope.currentTab = tab;

    $scope.refreshAdmissionGroupStats(null, tab);
  };

  $scope.refreshCurrentAdmissionGroupStats = function($event) {
    if ($event) $event.preventDefault();

    $scope.refreshAdmissionGroupStats(null, $scope.currentTab);
  };

  $scope.getNotes();

  function mapNotes(notes) {
    if (!notes || !notes.length) return null;

    return notes.map(note => {
      note.created = moment.utc(note.created, 'x');
      note.html = (note.text || '')
        .replace(/\n/g, '<br />')
        .replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig, '<a target="blank" href="$1">$1</a>'); //eslint-disable-line
      note.html = $sce.trustAsHtml(note.html);
      return note;
    });
  }
}

Ctrl.$inject = [
  '$scope',
  '$timeout',
  '$q',
  '$state',
  '$stateParams',
  'jsSdk.internalNote',
  'dateUtilsService',
  'angularSlideOutPanel',
  'jsSdk.utils',
  'alertService',
  'modalService',
  '$sce',
  'userPreferencesService',
  'jsSdk.event'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/manageDashboard/controller.js